import React from "react";
import { Button, Input, Table } from "reactstrap";

const ProviderListPage = () => {
  return (
    <>
      <Table responsive>
        <thead>
          <tr>
            <th>Company</th>
            <th>Owner</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Web Site</th>
            <th>Resources</th>
            <th>Notes</th>
            <th>Non-Profit</th>
            <th>Charge for Services</th>
            <th>Application Status</th>
            <th style={{ width: 140, textAlign: "right" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div style={{ width: "150px" }}>Valle Vista Health System</div>
            </td>
            <td>
              <div style={{ width: "150px" }}>Mary Ellen</div>
            </td>
            <td>
              <div style={{ width: 150 }}>mary.brown2@uhsinc.com</div>
            </td>
            <td className="cursorPointer">
              <div className="text-nowrap">+1-8123205126</div>
            </td>
            <td className="link cursorPointer">
              <div
                style={{ width: 150 }}
                // onClick={() => openLinkInNewTab(data?.providerWebsiteUrl)}
              >
                www.vallevista.com
              </div>
            </td>
            <td>
              3
              <Button
                color="link"
                style={{ width: 50 }}
                // onClick={() => _servicesHandler(data)}
              >
                <i style={{ fontSize: 17 }} className="fa fa-eye"></i>
              </Button>
            </td>
            <td>
              <Button
                color="link"
                // onClick={() => {
                //   _NotesModalToggle(true, data?._id);
                // }}
                style={{ width: 50 }}
              >
                <i className="fa fa-file mr-2"></i>
                <span>0</span>
              </Button>
            </td>

            <td>No</td>
            <td>Yes</td>
            <td>Accepted</td>

            <td>
              <div className="action">
                <Button
                  color="link"
                  className="btn-edit"
                  // onClick={() => _editHandler(data)}
                >
                  <i className="fa fa-pencil"></i>
                </Button>
              </div>
            </td>
          </tr>
        </tbody>
      </Table>
    </>
  );
};

export default ProviderListPage;
